var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-record-found table-spinner"},[_c('div',{staticClass:"middle-align"},[_c('div',{staticClass:"spinner-img"},[_c('img',{staticClass:"main",attrs:{"src":require("@/assets/images/loader.svg")}}),_c('p',[_vm._v("Loading...")])])])])
}]

export { render, staticRenderFns }